import * as React from "react";
import {
  modelKeyToDealTextMap,
  a11yKeyToTextMap,
  buildDatesLabel,
  getLink,
  getContent
} from "../checkPricesLocalization";
import { TrackedLink } from "src/components/utility/analytics/TrackedLink";
import { DealProps } from "../typings";
import { UitkCardTextSegment, UitkCardSectionSeparatorType } from "uitk-react-cards";
import { viewContext } from "../CheckPrices";
import { UitkLayoutGrid } from "uitk-react-layout-grid";
import { UitkLayoutFlexItem } from "uitk-react-layout-flex";

export const Deal: React.FC<DealProps> = ({ modelKey, model, searchContext, l10n }) => {
  if (modelKey !== "tomorrowNight" && (!modelKeyToDealTextMap[modelKey] || !model[modelKey])) {
    return null;
  }

  const content = getContent({ l10n, modelKey, model });
  const regionName: string = searchContext && searchContext.location && searchContext.location.name;
  const regionType: string = searchContext && searchContext.location && searchContext.location.type;
  const datesLabel = buildDatesLabel(l10n, content.isoStartDate, content.isoEndDate);

  const props = {
    a11yText: a11yKeyToTextMap[modelKey]({ regionName, datesLabel, regionType, l10n }),
    cardLink: getLink(content, modelKey),
    dates: datesLabel,
    label: modelKeyToDealTextMap[modelKey](l10n),
    modelKey
  };

  const view = React.useContext(viewContext);

  switch (view) {
    case "row":
      return <RowViewDeal {...props} />;
    default:
      return <DefaultDeal {...props} />;
  }
};

interface DealViewProp {
  a11yText: string;
  cardLink: string;
  dates: string;
  label: string;
  modelKey: string;
}

const DefaultDeal: React.FC<DealViewProp> = ({ a11yText, cardLink, dates, label, modelKey }) => (
  <UitkCardTextSegment
    className="cardTextContainer all-y-padding-four"
    separator={UitkCardSectionSeparatorType.TOP}
    key={modelKey}
  >
    <span className="dealText uitk-type-300 all-y-padding-one" aria-hidden={true}>
      {label}
    </span>
    <span className="icon-right uitk-type-300 uitk-link" aria-hidden={true}>
      <TrackedLink className="uitk-type-300 uitk-link" moduleName="check-prices" rfrr={modelKey} href={cardLink}>
        {dates}
      </TrackedLink>
    </span>

    <TrackedLink className="uitk-card-link" moduleName="check-prices" rfrr={modelKey} href={cardLink}>
      {a11yText}
    </TrackedLink>
  </UitkCardTextSegment>
);

const RowViewDeal: React.FC<DealViewProp> = ({ a11yText, cardLink, dates, label, modelKey }) => (
  <UitkLayoutFlexItem grow={1} minWidth="twenty_four">
    <UitkLayoutGrid className="all-t-padding-three">
      <span className="uitk-type-300 uitk-type-bold all-y-padding-one" aria-hidden={true}>
        {label}
      </span>
      <span className="is-visually-hidden">{a11yText}</span>

      <TrackedLink className="uitk-type-300 uitk-link" moduleName="check-prices_row" rfrr={modelKey} href={cardLink}>
        {dates}
      </TrackedLink>
    </UitkLayoutGrid>
  </UitkLayoutFlexItem>
);
